<template>
  <div class="testimonial-section">
    <div class="testimonial-nav">
      <span class="bar"> </span>
      <h2>{{$t("uquvchilar_fikri")}}</h2>
    </div>

 <swiper
      :modules="[Navigation]"
      :slides-per-view="1"
      :space-between="25"
      :autoplay="{ delay: 3000, disableOnInteraction: false }"
      :loop="true"
      :breakpoints="{
        1440: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 2.5,
        },
        768: {
          slidesPerView: 1,
        },
        // 480: {
        //   slidesPerView: 1,
        // }
  }"

  
  navigation
      class="testimonial-carousel2"
    >
      <swiper-slide
        v-for="(testimonial, index) in testimonials"
        :key="index"
        class="testimonial-card2"
      >
        <p>{{ testimonial.role }}</p>
        <p>{{ $t(testimonial?.descrioption) }}</p>
        <!-- <p>{{ testimonial.descrioption2 }}</p> -->
        <p class="testimonial_user_name">{{ testimonial.name }}</p>

        <!-- <div class="testimonial-footer2">
          <img :src="testimonial.image" alt="User Image" class="user-image" />
          <div class="testimonial-footer-text2">
            <p>{{ testimonial.role }}</p>
          </div>
        </div> -->
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import playvideo from '@/components/Template/Icons.vue'
export default {
  components: {
    Swiper,
    SwiperSlide,
    playvideo
  },
  setup() {
    return {
      Navigation,
      Autoplay,
    };
  },
  data() {
    return {
      testimonials: [
        {
          name: "-Murod, Web dasturlash kursi bitiruvchisi",
          role: " Web dasturlash (Frontend va Backend)",
          image: require("@/assets/Images/home_img/Mask group.svg"),
          image2: require("@/assets/Images/home_img/video-circle.png"),
          descrioption:
            "testimonials1",
        },
        {
          name: "– Kamola, Kiberxavfsizlik kursi ishtirokchisi",
          role: "Kiberxavfsizlik",
          image: require("@/assets/Images/home_img/Mask group.svg"),
          image2: require("@/assets/Images/home_img/video-circle.png"),
          descrioption:
            "testimonials2",
        },
        {
          name: "– Dilshod, Grafik dizayn kursi o‘quvchisi",
          role: "Grafik dizayner",
          image: require("@/assets/Images/home_img/Mask group.svg"),
          image2: require("@/assets/Images/home_img/video-circle.png"),
          descrioption:
          "testimonials3",
        },
        {
          name: "– Guli, SMM kursi bitiruvchisi",
          role: "SMM (Social Media Marketing)",
          image: require("@/assets/Images/home_img/Mask group.svg"),
          image2: require("@/assets/Images/home_img/video-circle.png"),
          descrioption:
           "testimonials4",
        },
        {
          name: "– Nigora, IT Kids kursi o‘quvchisining onasi",
          role: "IT Kids (Bolalar uchun IT kursi)",
          image: require("@/assets/Images/home_img/Mask group.svg"),
          image2: require("@/assets/Images/home_img/video-circle.png"),
          descrioption:
           "testimonials5",
        },
       
      ],
    };
  },
};
</script>

<style>
.testimonial-nav {
  display: flex;
  align-items: center;
  gap: 10px;
}
.testimonial-nav .bar {
  width: 4px;
  height: 43px;
  background: yellow;
}
.testimonial-nav h2 {
  font-size: 32px;
  font-weight: 500;
}
.testimonial_user_name{
  text-align: start;
}
.testimonial-section {
  position: relative;
  text-align: start;
  background: #000;
  color: white;
  margin-top: 35px;
  padding: 0;
}



.testimonial-carousel2 {
  width: 100%;
  position: relative;
  margin-top: 40px;
  height: 440px;
  margin-bottom: 30px;
}



.testimonial-card2 {
  max-width: 478px;
  height: 380px;
  padding:20px 30px;
  border-radius: 20px;
  background: rgba(13, 13, 13, 1);
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items:start;
}
.testimonial-card2 > p {
  font-size: 14px;
  color: rgba(255, 255, 255, 1);
  line-height: 20px;
  margin-top: 10px;
  font-family: Manrope;
  font-weight: 300;
}
.user-image-play{
  cursor: pointer;
}

.testimonial-footer2 {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 5%;
  margin-top: 20px;
  display: none;
}


.testimonial-footer-text2 h3 {
  font-size: 30px;
  font-family: Nohemi;
  font-weight: 500;
}


.testimonial-footer-text2 p {
  font-size: 10px;
  font-family: Manrope;
  font-weight: 400;
}


.user-image {
  width: 67px;
  height: 67px;
  border-radius: 50%;
}


.testimonial-carousel2::after {
  content: "";
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  width: 100px;
  height: 100%;
  background: linear-gradient(to left, rgba(0, 0, 0, 1), transparent);
  pointer-events: none;
}

.swiper-button-prev {
  box-sizing: content-box;
  position: absolute;
  z-index: 2;
  top: 97%;
  left: 94.5%;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  padding: 5px;
  background-color: #1f1c1c;

  color: #fff;
}

.swiper-button-next {
  box-sizing: content-box;
  /* z-index: 10; */
  position: absolute;
  top: 97%;
  right: 1px;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  padding: 5px;
  background-color: #fff;
  transition: all 0.3s ease;

  color: #000;
}
.swiper-button-next::after,
.swiper-button-prev::after {
  font-size: 14px;
  font-weight: 900;
}
.swiper-button-prev:hover,
.swiper-button-prev:active {
  background-color: #ffffff;
  color: #000;
}

.swiper-button-next:hover,
.swiper-button-next:active {
  background-color: #fff;
  color: #000;
}


@media (max-width: 480px) {
 

  .swiper-button-prev {
    left: 10% !important;
  
  }
  .testimonial-carousel2{
    height: 440px;
  }
  /* .testimonial-card2{
    height: auto;
  } */
  .swiper-button-next {
    right: 0 !important;
    /* margin-top: 10px; */
    background-color: #fff;
    color: #000;
    border-radius: 50%;
    padding: 5px;
  }
}
</style>
